import React from 'react';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../../config';

const Item = ({ data, index, item_type, delete_item }) => {
  return (
    <div className={`item-${item_type}`}>
      <SVG
        src={`${STATIC_PATH}/img/action-icons/clip-icon.svg`}
        height="20"
        width="20"
        cacheRequests
      />
      <span className="name">{data.name}</span>
      <span className="size">{data.size} kb</span>
      <span
        className="delete"
        onClick={(e) => {
          delete_item(index);
          e.preventDefault();
        }}
      >
        <SVG
          src={`${STATIC_PATH}/img/action-icons/cross-icon.svg`}
          height="13"
          width="13"
          cacheRequests
        />
      </span>
    </div>
  );
};

export default Item;
